export const rupiah = (n) =>
  "Rp " + Math.round(Number(n) || 0).toLocaleString("id-ID");

export const rupiahShort = (n) => {
  const v = Number(n) || 0;
  if (Math.abs(v) >= 1_000_000) return "Rp " + (v / 1_000_000).toFixed(1).replace(/\.0$/, "") + "jt";
  if (Math.abs(v) >= 1_000) return "Rp " + (v / 1_000).toFixed(0) + "rb";
  return rupiah(v);
};

export const num = (n) => (Number(n) || 0).toLocaleString("id-ID");

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Ags", "Sep", "Okt", "Nov", "Des"];

export const fmtDate = (d) => {
  if (!d) return "-";
  const dt = new Date(d);
  if (isNaN(dt)) return "-";
  return `${dt.getDate()} ${MONTHS[dt.getMonth()]} ${dt.getFullYear()}`;
};

export const fmtDateTime = (d) => {
  if (!d) return "-";
  const dt = new Date(d);
  if (isNaN(dt)) return "-";
  const hh = String(dt.getHours()).padStart(2, "0");
  const mm = String(dt.getMinutes()).padStart(2, "0");
  return `${fmtDate(d)} ${hh}:${mm}`;
};

export const relDay = (d) => {
  if (!d) return "";
  const dt = new Date(d);
  const today = new Date();
  const diff = Math.round((new Date(dt.getFullYear(), dt.getMonth(), dt.getDate()) - new Date(today.getFullYear(), today.getMonth(), today.getDate())) / 86400000);
  if (diff === 0) return "Hari ini";
  if (diff === 1) return "Besok";
  if (diff === -1) return "Kemarin";
  return fmtDate(d);
};
